export enum TimeListEnum {
  'sevenAM' = '07:00 AM',
  'eightAM' = '08:00 AM',
  'nineAM' = '09:00 AM',
  'tenAM' = '10:00 AM',
  'elevenAM' = '11:00 AM',
  'noon' = '12:00 PM',
  'onePM' = '01:00 PM',
  'twoPm' = '02:00 PM',
  'threePM' = '03:00 PM',
}